<template>
    <main-layout>
        <data-load>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </data-load>
    </main-layout>
</template>

<script>
  import MainLayout from './framework/MainLayout'
  import DataLoad from "./framework/gates/DataLoad";
  export default {
    components : {
      MainLayout,
      DataLoad
    },
    data(){
      return {
        saveInterval : null,
      }
    },
    mounted() {
     this.saveInterval = setInterval(()=>{
       this.save();
      },5000);
    },
    methods:{
      save(){
        if(this.$store.getters['auth/isLoggedIn']){
          this.$store.dispatch('assessment/saveAnswerBuffer');
          this.$store.dispatch('assessment/saveAuditLogBuffer');
        }

      }
    },
    beforeDestroy() {
      clearInterval(this.saveInterval);
      this.save();
    }
  }
</script>

<style scoped>

</style>